import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-20">
      <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>

      <p className="mb-4">
        Stash Masters respects your privacy and is committed to protecting your
        personal information. This policy explains how we collect, use, and
        safeguard your information when you visit our website.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        Information We Collect
      </h2>
      <p className="mb-4">
        We may collect personal information such as your name, phone number,
        email address, and any details you provide when contacting us.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">
        How We Use Your Information
      </h2>
      <p className="mb-4">
        Your information is used only to respond to inquiries, provide services,
        and improve our website experience.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-3">Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact
        Stash Masters.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
